// extracted by css-extract-rspack-plugin
export default {"wrapper":"Targetings-module__wrapper--huoD6"};